<template>
  <div id="post_container" @click="nav_to_article">
    <div id="post" :style="'background-image: linear-gradient(270deg, rgba(0,0,0), rgba(0,0,0,0) 95%), url(' + post_img_extended(post) + ')'">
      <div id="post_subcontainer">
        <h3>{{post.title}}</h3>
        <p>{{post.summary}}</p>

        <div id="spacer">&nbsp;</div>

        <router-link :to="'/post/' + post.path" id="read_more">
          Read More
          <img src="@/assets/imgs/new_arrow-right.svg" style="width: 16px"/>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import HasPost   from "@/mixins/HasPost"

export default {
  name: "ArticleItem",

  mixins: [
    HasPost
  ],

  methods: {
    nav_to_article: function () {
      this.$router.push(`/post/${this.post.path}`)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#post_container{
  background-image: linear-gradient($grey-7-alpha62, $black-alpha62);
  border-radius: 15px;
  margin: 50px 0;
  padding: 5px;
  height: 350px;
  cursor: pointer;
}

#post{
  border-radius: 15px;
  display: flex;
  justify-content: flex-end;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
}

#main_layout_v2.xs #post{
  background-position-x: 0, -200px;
}

#post_subcontainer{
  background-image: linear-gradient($grey-5-alpha75, $black-alpha75 50%);
  width: 50%;
  height: 90%;
  margin: 15px;
  padding: 40px;
  padding-right: 15px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  font-family: Alliance No2;
}

#main_layout_v2.lg #post_subcontainer {
  margin: 5px;
  height: 97%;
}

#main_layout_v2.md #post_subcontainer{
  width: 45%;
}

#main_layout_v2.sm #post_subcontainer{
  width: 65%;
}

#main_layout_v2.xs #post_subcontainer{
  width: unset;
}

#post_subcontainer h3{
  font-family: Sunset Gothic Pro Heavy;
}

#main_layout_v2.lg #post_subcontainer h3{
  font-size: 1.5rem;
}

#main_layout_v2.xs #post_subcontainer h3{
  font-size: 1.1rem;
}

#spacer{
  flex-grow: 1;
}

#read_more{
  border-bottom: 1px solid $sunset-coral;
  margin-top: 5px;
  color: $white;
  width: fit-content;
  align-self: end;
}

#read_more:hover{
  text-decoration: none;
}
</style>
